import React from "react";
import { Grid } from "Components/Base/Layout";
import SelectFilter from "./SelectFilter";
import { STYLE_GRID_ITEM, STYLE_SELECT_FILTER } from "../../styles";

const CategoryFilters = ({
  languageContext,
  categories,
  categoriesValue,
  onChange,
  isMobile,
  totalFilterGroupsCount,
}) => (
  <>
    {categories?.map((category, index) => {
      const categoryName = `category${index + 1}`;
      return (
        <Grid item xs={12} key={categoryName} sx={STYLE_GRID_ITEM}>
          <SelectFilter
            label={languageContext(category.title)}
            value={categoriesValue[categoryName]}
            onChange={onChange}
            menuItems={category.items.map((item) => ({
              title: item.title,
              value: item.id,
            }))}
            defaultMenuItemLabel={languageContext("all")}
            categoryName={categoryName}
            sx={isMobile ? { marginBottom: 1 } : STYLE_SELECT_FILTER}
            isMobile={isMobile}
            totalFilterGroupsCount={totalFilterGroupsCount}
          />
        </Grid>
      );
    })}
  </>
);

export default CategoryFilters;
